goog.provide("shadow.js.shim.module$$mui$material$InputLabel");
goog.provide("module$shadow_js_shim_module$$mui$material$InputLabel");
shadow.js.shim.module$$mui$material$InputLabel = shadow.js.nativeProvides["@mui/material/InputLabel"] = shadow$bridge("@mui/material/InputLabel");
module$shadow_js_shim_module$$mui$material$InputLabel.default = shadow.js.shim.module$$mui$material$InputLabel;
